import { Link } from 'react-router-dom';
import { eventsData } from '@/mocks/home';

const statusStyles: Record<string, string> = {
  '报名中': 'bg-accent-500 text-background-50',
  '即将开始': 'bg-secondary-500 text-background-50',
  '预告': 'bg-foreground-300 text-foreground-800',
};

export default function EventsSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 gap-4">
          <div>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-2">精彩赛事</h2>
            <p className="text-foreground-600 text-base">参与精彩赛事，挑战自我极限</p>
          </div>
          <Link
            to="/category/events"
            className="flex items-center gap-1.5 text-primary-600 font-medium text-sm whitespace-nowrap hover:text-primary-700 transition-colors cursor-pointer"
          >
            查看全部赛事 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {eventsData.map((event) => (
            <Link
              key={event.id}
              to={`/article/${event.id}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 transition-all hover:scale-[1.02] cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={event.image}
                  alt={event.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className={`absolute top-3 right-3 px-3 py-1 rounded-full text-xs font-semibold ${statusStyles[event.status]}`}>
                  {event.status}
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3 line-clamp-2">{event.title}</h3>
                <div className="flex items-center gap-4 text-sm text-foreground-600">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-calendar-line text-primary-500"></i> {event.date}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <i className="ri-map-pin-line text-primary-500"></i> {event.location}
                  </span>
                </div>
                {event.participants > 0 && (
                  <div className="mt-3 pt-3 border-t border-background-200/70 flex items-center gap-1.5 text-sm text-foreground-500">
                    <i className="ri-team-line"></i> 已报名 <strong className="text-primary-600">{event.participants}</strong> 人
                  </div>
                )}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}